import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { SocketState } from './model';

const initialState: SocketState = {
  connected: false,
  joined: false,
  disconnected: false,
  inviteData: null,
  blockwalkData: null,
  candidateData: null,
  tagData: null,
  syncData: null,
};

const socketSlice = createSlice({
  name: '@socket',
  initialState,
  reducers: {
    userJoinedSocket(state) {
      state.connected = true;
      state.joined = true;
    },
    socketDisconnect(state, action: PayloadAction<boolean>) {
      state.disconnected = action.payload;
    },
    inviteUpdate(state, action: PayloadAction<SocketState['inviteData']>) {
      state.inviteData = action.payload;
    },
    blockwalkUpdate(state, action: PayloadAction<SocketState['blockwalkData']>) {
      state.blockwalkData = action.payload;
    },
    candidateUpdate(state, action: PayloadAction<SocketState['candidateData']>) {
      state.candidateData = action.payload;
    },
    tagUpdate(state, action: PayloadAction<SocketState['tagData']>) {
      state.tagData = action.payload;
    },
    updateContact(state, action: PayloadAction<SocketState['syncData']>) {
      state.syncData = action.payload;
    },
  },
});

export const socketActions = socketSlice.actions;

export default socketSlice.reducer;
